module.exports = __webpack_public_path__ + "static/lucas-a83be5456169274cc1ee5f24a29bfde3.png";